import { CommandProps, Extension } from "@tiptap/core";
import { findParentNodeClosestToPos } from "@tiptap/core";
import { TableMap } from "prosemirror-tables";

import "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    freezeTable: {
      freezeColumn: () => ReturnType;
      freezeRow: () => ReturnType;
      clearFreeze: () => ReturnType;
    };
  }
}

export const FreezeTableCommand = Extension.create({
  name: "freezeTable",

  addCommands() {
    return {
      freezeColumn:
        () =>
        ({ state, dispatch }) => {
          const { $from } = state.selection;

          const table = findParentNodeClosestToPos(
            $from,
            (node) => node.type.name === "table",
          );
          if (!table) return false;

          const cell = findParentNodeClosestToPos(
            $from,
            (node) =>
              node.type.name === "tableCell" ||
              node.type.name === "tableHeader",
          );
          if (!cell) return false;

          const map = TableMap.get(table.node);
          const cellPos = cell.pos - table.pos - 1;
          const { left: colIndex } = map.findCell(cellPos);

          const tr = state.tr;

          for (let row = 0; row < map.height; row++) {
            const index = row * map.width + colIndex;
            const offset = map.map[index];
            if (offset == null) continue;

            const pos = table.pos + 1 + offset;
            const node = tr.doc.nodeAt(pos);
            if (!node) continue;

            tr.setNodeMarkup(pos, undefined, {
              ...node.attrs,
              freezeCol: true,
            });
          }

          dispatch?.(tr);
          return true;
        },
      freezeRow:
        () =>
        ({ state, dispatch }) => {
          const { $from } = state.selection;

          const table = findParentNodeClosestToPos(
            $from,
            (node) => node.type.name === "table",
          );
          if (!table) return false;

          const cell = findParentNodeClosestToPos(
            $from,
            (node) =>
              node.type.name === "tableCell" ||
              node.type.name === "tableHeader",
          );
          if (!cell) return false;

          const map = TableMap.get(table.node);
          const cellPos = cell.pos - table.pos - 1;
          const { top: rowIndex } = map.findCell(cellPos);

          const tr = state.tr;

          for (let col = 0; col < map.width; col++) {
            const index = rowIndex * map.width + col;
            const offset = map.map[index];
            if (offset == null) continue;

            const pos = table.pos + 1 + offset;
            const node = tr.doc.nodeAt(pos);
            if (!node) continue;

            tr.setNodeMarkup(pos, undefined, {
              ...node.attrs,
              freezeRow: true,
            });
          }

          dispatch?.(tr);
          return true;
        },

      clearFreeze:
        () =>
        ({ state, dispatch }: CommandProps) => {
          const { $from } = state.selection;

          const table = findParentNodeClosestToPos(
            $from,
            (node) => node.type.name === "table",
          );
          if (!table) return false;

          const tr = state.tr;

          const cellsToClear: number[] = [];
          table.node.descendants((node, pos) => {
            if (
              node.type.name === "tableCell" ||
              node.type.name === "tableHeader"
            ) {
              if (node.attrs.freezeRow || node.attrs.freezeCol) {
                cellsToClear.push(table.pos + 1 + pos);
              }
            }
          });

          for (const pos of cellsToClear) {
            const node = tr.doc.nodeAt(pos);
            if (!node) continue;

            tr.setNodeMarkup(pos, undefined, {
              ...node.attrs,
              freezeRow: null,
              freezeCol: null,
            });
          }

          dispatch?.(tr);
          return true;
        },
    };
  },
});
